import {combineReducers} from 'redux';
import aptitudeReducer, {tooltipReducer} from 'src/redux/aptitude/reducer';

export default combineReducers({
  aptitude: aptitudeReducer,
  tooltips: tooltipReducer,
});
